import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GoogleAnalytics = () => {
  const location = useLocation();
  const MEASUREMENT_ID = "G-7N6HZLCVGE";

  useEffect(() => {
    // Инициализация на Google Analytics
    const initGA = () => {
      // Добавяне на основния скрипт
      const script = document.createElement("script");
      script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
      script.async = true;
      document.head.appendChild(script);

      // Инициализиране на gtag
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", MEASUREMENT_ID, {
        send_page_view: false,
      });
    };

    // Проверка дали вече е инициализирано
    if (!window.gtag) {
      initGA();
    }
  }, []);

  useEffect(() => {
    // Проследяване на page view при промяна на рутата
    const trackPageView = () => {
      if (window.gtag) {
        window.gtag("event", "page_view", {
          page_title: document.title,
          page_path: location.pathname + location.search,
          page_location: window.location.href,
        });
      }
    };

    // Забавяне за сигурност, че страницата е заредена
    const timer = setTimeout(trackPageView, 300);

    return () => clearTimeout(timer);
  }, [location]);

  return null;
};

export default GoogleAnalytics;
